var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-mask",style:(_vm.maskStyle)},[_c('div',{staticClass:"loading-wrapper",style:(_vm.wrapperStyle)},[_c('div',{staticClass:"loading-spinner",style:(_vm.spinnerStyle)}),_c('div',{staticClass:"loading-text",style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }